export default "/pt-reth.46e3e8134c61eb5b963561854c4b47eb.svg";